import { useMemo } from 'react';
import { useAuth } from '@/lib/auth-context';
import type { WidgetConfig } from '@/components/dashboard';
import {
  PrayerCountWidget,
  UserCountWidget,
  TodayStatsWidget,
  CategoryWidget,
  AdminActionsWidget,
} from '@/components/dashboard/widgets';

export function useDashboardLayout() {
  const { user } = useAuth();

  const widgets = useMemo((): WidgetConfig[] => {
    if (!user) return [];

    switch (user.role) {
      case 'admin':
        return [
          {
            id: 'admin-actions',
            type: 'quick-actions',
            title: 'Quick Actions',
            component: AdminActionsWidget,
            defaultLayout: { x: 0, y: 0, w: 6, h: 4, minW: 4, minH: 3 },
          },
          {
            id: 'user-count',
            type: 'stats',
            title: 'User Statistics',
            component: UserCountWidget,
            defaultLayout: { x: 6, y: 0, w: 6, h: 4, minW: 4, minH: 3 },
          },
          {
            id: 'prayer-count',
            type: 'stats',
            title: 'Prayer Statistics',
            component: PrayerCountWidget,
            defaultLayout: { x: 0, y: 4, w: 6, h: 3, minW: 4, minH: 3 },
          },
          {
            id: 'today-stats',
            type: 'stats',
            title: 'Recent Activity',
            component: TodayStatsWidget,
            defaultLayout: { x: 6, y: 4, w: 6, h: 3, minW: 4, minH: 3 },
          },
          {
            id: 'category-breakdown',
            type: 'category-breakdown',
            title: 'Category Breakdown',
            component: CategoryWidget,
            defaultLayout: { x: 0, y: 7, w: 12, h: 3, minW: 6, minH: 3 },
          },
        ];

      default:
        return [];
    }
  }, [user]);

  const storageKey = useMemo(() => {
    return `dashboard-layout-${user?.role ?? 'guest'}`;
  }, [user?.role]);

  return { widgets, storageKey };
}
